export default {
  app: {
    title: "Soul-Profiler",
    shorttitle: "SOPR",
    subtitle: "Ondernemen met je ziel",
    subtitle2: "Ontdek jouw levensdoel",
    buttons: {
      donate: "Doneer",
      soulprofile: "Soul-Profile®",
      relationprofile: "Love-Profile®",
      friendshipprofile: "Vrienden Profile",
      familyprofile: "Familie Profile",
      groupprofile: "Groeps Profile",
      lovelanguage: "Liefde sturen",
      purposegenerator: "Purpose Generator",
      calculate: "Uitrekenen",
      surveypage: "Hoe bezield leef jij?",
      generate: "Genereer",
      RESET: "Opnieuw",
      NEW: "Nieuw",
      UPDATE: "Update",
      dayenergy: "Energie van de dag",
      PROBLEM_SOLVER: "Problem Solver®",
      TO_DAYENERGY: "ervaar de dag energie",
      today: "vandaag",
      CANCEL: "Annuleer",
      OK: "Ok",
      SAVE: "Opslaan",
      CLEAR: "Leegmaken",
      DELETE: "Verwijder",
      REGISTER: "Registreren",
      RESEND: "Opnieuw versturen",
      LOGIN: "Inloggen",
      SIGNOUT: "Uitloggen",
      LOADING: "Laden...",
      FORWARD: "Verdergaan",
      START: "Start",
      COPY_LINK: "Link kopiëren",
      UPDATE_APP: "Update App",
      PURPOSE: "Je Purpose",
      SOUL_PROFILE: "Soul Profile",
      LOVE_PROFILE: "Love-Profile",
      FRIEND_PROFILE: "Friend-Profile",
      ACCOUNT_YES_CLICK_HERE: "Heb je al een account? Klik hier",
      ACCOUNT_NO_CLICK_HERE: "Heb je nog geen account? Klik hier",
      FORGOT_PASSWORD: "Wachtwoord vergeten?",
      RESEND_VERIFICATION: "Verificatie email opnieuw verzenden",
      SEND_LOVE: "Liefde verzenden",
      SEND_LOVE_MESSAGE: "stuur zelf liefde",
      SHARE: "delen",
      CLOSE: "sluiten",
      PRINT_TO_PDF: "Print naar PDF",
      SAVE_TO_PDF: "Opslaan als PDF",
      SAVE_IMAGE_JPG: "Opslaan als JPG",
      SAVE_IMAGE_PNG: "Opslaan als PNG",
      PRINT: "Print",
      CHANGE_DATA: "Gegevens veranderen",
      INPUT_USER_DATA: "Vul gegevens in",
      DISCOVER_MORE: "ontdek meer",
      BUY_SOULPROFILER_REPORT: "Bestel Soul-Profiler rapport",
      GENERATE_REPORT: "Genereer rapport",
      ORDER_REPORT: "bestel rapport",
      DONATE_AMOUNT: "Doneer €{amount}",
      ADD_NAME: "Voeg naam toe",
      START_HERE: "Start hier",
      YES: "Ja",
      NO: "Nee",
      LIVE_READING: "Live reading ({amount})",
      ONLINE_READING: "Online reading ({amount})",
      INTRO_READING: "Introductie reading ({amount})",
      BOOK_READING: "Live reading ({amount})",
      BOOK_A_READING: "Boek een reading",
      READ_MORE: "Lees meer",
      ORDER_BOOK: "Bestel hier",
      SAVE_IMAGE: "Afbeelding opslaan",
      LOVE_TEST: "Liefdes test",
      ADMIN_PAGE: "Admin pagina",
    },
    dialogs: {
      dialogdata: { title: "Vul je gegevens in" },
      dialogshare: {
        title: "Soul Profile delen",
        text: "Deel je favoriete Soul-Profile met vrienden.",
      },
      liveReading: {
        title: "Boek een online reading",
        description:
          "Laat je levensvraag beantwoorden en krijg direct inzicht. Kies jouw sessie om vandaag nog helderder verder te gaan!",
      },
      powercard: { title: "Scheppingskracht" },
      minireading: {
        titleToolbar: "Mini Reading",
        BOOK_LIVE_READING: "Live reading {price}",
        YOUR: "jouw",
        ON_THE: "op het",
        disclaimer: {
          title: "disclaimer",
          text: `Boek een live reading om dieper in te gaan op jouw unieke creatiekrachten en een uitdaging in je leven. De live reading is een persoonlijke sessie van 30 minuten waarin je meer inzicht krijgt in jouw unieke blauwdruk.`,
        },
      },
      generatereport: {
        title: "Genereer jouw unieke Soul-Profiler rapport",
        text: "Bestel je eigen unieke Soul-Profiler boek. Een digitaal rapport voor jezelf of iemand anders voor maar {amount}",
        text2:
          "Je ontvangt je persoonlijke digitaal boek binnen 7 dagen na betaling in je inbox.",
        button: "Bestel nu",
        button_paperback: "Bestel Persoonlijk Boek {amount}",
        button_digital: "Bestel blauwdruk PDF {amount}",
      },
      problemsolver: {
        TITLE: "Problem Solver®",
        ARE_YOU_FACING_A_PROBLEM:
          "Loop je tegen een uitdaging aan in je leven?",
        CAN_YOU_FIX_IT: "Kun je het zelf oplossen?",
        FIX_IT_NOW:
          "Fantastisch!! Jij verdient een mooiere realiteit. Neem vandaag een eerste stapje om het op te lossen! Doe het nu!",
        PROBLEM_SOLVER: "Problem Solver",
        CALL_SUPPORT: "Bel voor hulp 06- 28973952",
        BOOK_A_READING:
          "Vraag hulp of boek een soulprofiler reading en krijg inzicht in je situatie",
        NO_PROCRASTINATION: "DOE HET NU! Van uitstel komt afstel",
      },
    },
    titles: { GENERATE_REPORT: "Bestel je boek", DAY_ENERGY: "Dag Energie" },
    pages: {
      login: { toolbarTitle: "Inloggen" },
      account: { toolbarTitle: "Je Account" },
      updatepassword: { toolbarTitle: "Update Wachtwoord" },
      index: { toolbarTitle: "Soul Profiler" },
      compass: { toolbarTitle: "SoulProfiler Kompas" },
      booklanding: {
        toolbarTitle: "Soulprofiler – Het Boek",
        title: "Soulprofiler – Het Boek (incl. €50 bonus)",
      },
      parentsLanding: {
        toolbarTitle: "Soulprofiler voor ouders",
      },
      soulprofile: {
        toolbarTitle: "Soul Profile",
        title: "Jouw Soul Profile",
        dialog: { title: "Vul je gegevens in" },
      },
      relationprofile: {
        toolbarTitle: "De ideale Partner",
        title: "Jullie Liefdes krachten",
        dialog: { title: "Vul de gegevens in" },
      },
      friendshipprofile: {
        toolbarTitle: "Vrienden kracht",
        title: "Jullie Scheppingskrachten",
        dialog: { title: "Vul de gegevens in", user: "Ziel" },
      },
      lovelanguage: {
        toolbarTitle: "Liefde sturen",
        text: "",
      },
      purposegenerator: {
        toolbarTitle: "Purpose Generator",
        subtitle: "Jouw taak hier op aarde",
        sentence: {
          preamble: "Lieve",
          pretext: "jij mag ",
          and: "en",
          karma: "Je moeilijkste thema",
          talent: "Je talent",
          soulvibration: "Zielstrilling",
        },
      },
      dayenergy: {
        toolbarTitle: "Dag Energie",
        dayTitle: "De energie van de dag",
        day: "Dag",
        monthTitle: "Thema van de maand",
        teaserTitle: "Dagthema",
      },
      potato: { toolbarTitle: "Potato Darshan" },
      democard: { toolbarTitle: "Demo Card" },
      calculatenumbers: { toolbarTitle: "Getallen uitrekenen" },
      printwheel: { toolbarTitle: "Print wiel" },
      surveypage: { toolbarTitle: "Doe de test" },
      customerpage: { toolbarTitle: "Klant" },
      adminsettings: { toolbarTitle: "Admin Instellingen" },
      bookinterest: { toolbarTitle: "Boek Interesse" },
      shop: { toolbarTitle: "Winkel" },
      shoptest: { toolbarTitle: "Testbetaling" },
      checkoutSuccess: { toolbarTitle: "Bestelling ontvangen" },
      checkoutCancelled: { toolbarTitle: "Betaling geannuleerd" },
      orderStatus: { toolbarTitle: "Bestelstatus" },
      pdfreport: {
        toolbarTitle: "PDF Rapport",
        cover: {
          brand: "Soulprofiler",
          tagline: "Persoonlijk Soulprofiler Rapport",
          title: "Jouw vijf creatiegetallen",
          subtitle:
            "Een eerste blik op jouw medicijnwiel en de beweging van jouw energie.",
          nameLabel: "Naam",
          birthdateLabel: "Geboortedatum",
          reportDateLabel: "Datum rapport",
          note: "Dit rapport is een eerste laag van jouw wiel. Verdieping ontstaat wanneer je ermee gaat spelen in je dagelijks leven.",
        },
        intro: {
          kicker: "INTRODUCTIE",
          title: "Het Medicijnwiel",
          lead: "Het medicijnwiel is een oude wijsheid die de cyclus van leven, groei en transformatie volgt. Het is een cirkel van energie die in vier richtingen beweegt, met het hart als centraal ankerpunt. Jouw <span  class='emphasis'>vijf getallen</span> vormen samen je persoonlijke <span  class='emphasis'>creatiekompas</span>. Ze laten zien hoe je denkt, doet, voelt, aanwezig bent in de materie en wat je <span  class='emphasis'>hart werkelijk verlangt</span>. De vier richtingen en het hart vormen een levende cirkel: een oneindige cyclus die je uitnodigt om jouw unieke balans te vinden, zodat jij een <span  class='emphasis'>medicijn voor meer liefde</span> kunt zijn in je omgeving.\n\n<span  class='emphasis'>Het Noorden</span> staat voor denken en ingevingen. <span  class='emphasis'>Het Oosten</span> is doen, stappen zetten en richting kiezen. <span  class='emphasis'>Het Zuiden</span> is voelen, emotie en stroming. <span  class='emphasis'>Het Westen</span> is aarde, lichaam en vertraagde energie. <span  class='emphasis'>Het hart</span> verbindt alles en fluistert jouw innerlijke waarheid. Het opent wanneer de thema’s van alle richtingen in balans komen. Elke richting heeft een <span  class='emphasis'>mannelijke</span> en een <span  class='emphasis'>vrouwelijke</span> kant. De mannelijke kant duwt, stuurt of versnelt. De vrouwelijke kant voelt, wacht, verzacht of trekt zich terug. Wanneer je beide polen herkent, ontstaat <span  class='emphasis'>keuzevrijheid</span>. Je hoeft niet in één uiterste te blijven; je mag bewegen en spelen met de energie.\n\nJe <span  class='emphasis'>geboortedatum activeert vijf krachten</span> in een uniek patroon. Daarmee heb je een eigen taak gekregen in tijd en ruimte. Dit patroon is jouw <span  class='emphasis'>creatiewiel</span>: een blauwdruk voor hoe jij kiest, groeit en invloed hebt op jouw realiteit. Wanneer je dit wiel in je lichaam voelt, wordt het praktisch. Je merkt welke kant actief is, welke kant je overslaat en of je in <span  class='emphasis'>duwen</span> (mannelijk) of <span  class='emphasis'>terugtrekken</span> (vrouwelijk) belandt. Balans ontstaat wanneer je met deze beweging speelt. Wordt iets te hard, <span  class='emphasis'>verzacht</span>. Wordt iets te zacht of terughoudend, <span  class='emphasis'>neem een stap</span>. Zo wordt het wiel een kompas dat je steeds terugbrengt naar jouw midden.\n\nHet wiel nodigt je uit om te vertrouwen op je <span  class='emphasis'>zuiverheid</span>, je ingevingen, je intuïtie en je gevoel. Deze zijn uniek en dragen een <span  class='emphasis'>medicinale kracht</span> in zich: het medicijn tegen liefdeloosheid en ontzieling.",
          numbersTitle: "Jouw vijf getallen",
          footer: "soulprofiler.com",
          cards: {
            heart: { label: "Ziel", caption: "Hart / centrum" },
            air: { label: "Missie", caption: "Noord / lucht" },
            fire: { label: "Talent", caption: "Oost / vuur" },
            water: { label: "Uitdaging", caption: "Zuid / water" },
            earth: { label: "Pad", caption: "West / aarde" },
          },
        },
        pages: {
          heart: {
            kicker: "HART / CENTRUM",
            title: "Zielsgetal {number} - {theme}",
          },
          air: {
            kicker: "NOORD / LUCHT",
            title: "Levensmissie {number} - {theme}",
          },
          fire: {
            kicker: "OOST / VUUR",
            title: "Talent {number} - {theme}",
          },
          water: {
            kicker: "ZUID / WATER",
            title: "Uitdaging {number} - {theme}",
          },
          earth: {
            kicker: "WEST / AARDE",
            title: "Levenspad {number} - {theme}",
          },
          dynamics: {
            kicker: "INTERACTIE",
            title: "Dynamiek tussen de getallen",
          },
          summary: {
            kicker: "SAMENVATTEND",
            title: "Jouw duiding",
            closingNote:
              "Merk op welke zinnen het meest blijven hangen. Dat zijn vaak de plekken waar jouw wiel je uitnodigt om verder te kijken.",
          },
        },
      },
    },
    components: {
      meditationTimer: {
        bar: { title: "Potato Meditatie Timer" },
        text: {
          meditating: "Be like Potato",
          notMeditating: "Potato Time",
        },
        buttons: {
          start: "start",
          resume: "hervat",
          reset: "reset",
          stop: "stop",
          pause: "pauze",
        },
      },
    },
    labels: {
      birthdate: "Geboorte datum (dd-mm-yyyy)",
      firstname: "voornaam",
      email: "e-mail adres",
      password: "wachtwoord",
      password_repeat: "wachtwoord herhalen",
      energy: "energie",
      IN: "in",
      OUT: "uit",
      MALE: "Mannelijk",
      FEMALE: "Vrouwelijk",
      FIND_BALANCE: "Balans tussen",
      powercard: "creatiekracht kaart",
      REGISTER: "Registreer",
      LOGIN: "Inloggen",
      RESET_PASSWORD: "Wachtwoord updaten",
      DEAR: "Lieve",
      MESSAGE: "Je berichtje",
      MEANING_CREATION_NUMBER: "Betekenis creatiegetal",
      INNER_CORE_THEMES: "Jouw binnenwereld thema's",
      OUTER_WORLD_THEMES: "Jouw buitenwereld thema's",
      SHORTCUT_PURPOSE: "Shortcut naar je levensdoel",
      PURPOSE: "Levensdoel",
      TAKE_SURVEY: "Doe de test",
      SURVEY_PAGE_TITLE: "test hoeveel jouw hart is gevuld",
      WELCOME_SOUL_PROFILER: "Welkom Soul-Profiler",
      YOUR_WHEEL: "Jouw medicijnwiel",
      YOUR_SOUL_PROFILE: "Jouw Soul-Profile",
      YOUR: "Jouw",
      RESEND_VERIFICATION_MAIL: "Verstuur verificatie email opnieuw",
      ONE_COFFEE: "één kop koffie",
      TWO_COFFEE: "twee koppen koffie",
      THREE_COFFEE: "drie koppen koffie",
      EXCL_IDEAL_TRANSACTION_COSTS: "excl. iDEAL transactiekosten",
      PREVIOUS_USERS: "Voorgaande Wielen",
    },
    emails: {
      orderReport: {
        subject: "Bestelling Soul-Profiler raport",
        body: "Hi,\n\nik zou graag een Soul-Profiler rapport willen bestellen.\n\nMijn gegevens zijn:\n\nNaam: {name}\nGeboortedatum: {date}.\n\nIk ben zoooo benieuwd!\n\nMet vriendelijke groet,\n{name}",
      },
    },
    messages: {
      update: "Update beschikbaar",
      underconstruction:
        "Hier komt een uitgebreide uitleg over het creatie getal op dit element. Kom gauw een keer terug, want dit wil je niet missen.",
      choice: "Maak je keuze",
      LIVE_READING_TEXT:
        "Heb jij een vraag waar je al even mee loopt? Tijdens een korte reading krijg je helder en direct antwoord, afgestemd op jouw unieke soulprofile. Ontvang inzicht, helderheid en richting in 30 minuten.",
      welcome: [
        "Volg vandaag je hartsverlangen",
        "Zet vandaag een stapje",
        "Alles is trilling en informatie",
        "Vandaag is nu",
        "Ben vandaag lief voor jezelf",
        "Sta even stil bij je uitdaging",
        "Je zielstrilling fluistert",
        "Volg jij je hartsverlangen?",
        "Wat is je intentie vandaag?",
        "Wat is je uitdaging?",
        "Sta vandaag even stil bij jezelf",
        "Waar ben je dankbaar voor?",
        "Neem tijd voor jezelf",
        "Speel vandaag met de energie van de dag",
        "Jij verdient een gouden stoel sessie",
        "Stuur eens een lief berichtje naar iemand",
        "Om hulp vragen is een daad van liefde",
        "Balans is de sleutel",
        "Bezield leven is niet altijd makkelijk",
        "Eis jouw bestaansrecht op",
        "Vergeving is jezelf bevrijden uit je eigen gevangenis van je mind",
      ],
      WHAT_TO_DO_IN_THIS_APP: [
        "Ontdek je unieke scheppingskrachten met je <a href='/soulprofile'>Soul-Profile</a>",
        "Mediteer eens 10 minuten met de <a href='/dayenergy'>dag energie</a>",
        "Check de thema's van je relatie en ervaar meer liefde in je leven",
        "Stuur eens een lief berichtje naar iemand. <a href='/lovelanguage'>Stuur liefde.</a>",
        "Ontdek je levendoel met de <a href='/purposegenerator'>purpose generator</a>",
        "Leer je karma of moeilijkste thema in je leven kennen met je <a href='/soulprofile'>Soul-Profile</a>",
        "Meet jouw purpose score op de survey pagina. De surveys zijn nog in beta en ergens verstopt op deze pagina",
        "Klik op het potato icoontje voor <a href='/potatodarshan'>Darshan van Potato</a>. Hij is zo schattig",
        "Schenk meer aandacht en liefde aan jezelf. <a href='/lovelanguage'>Stuur meer liefde</a> de wereld in",
        "Ontdek jouw unieke talent in je <a href='/soulprofile'>Soul-Profile</a>",
        "Vindt balans in je leven met jouw Soul-Profiler blauwdruk",
        "Leef een meer bezield leven met behulp van de medicijnwiel numerologie in de Soul-Profiler",
        "Ontvang een minireading bij jouw <a href='/soulprofile'>Soul-Profile</a> en ontdek jouw potentieel",
        "Boek een <a href='https://tidycal.com/verdieping7/soul-profiler-reading' target='_blank'>live reading</a> op jouw Soul-Profile en je medicijnwiel blauwdruk voor maar €25,-",
      ],
      LINK_COPIED: "Link naar clipboard gekopieerd. Deel het waar je wil.",
      LOVE_COPIED:
        "Liefde naar clipboard gekopieerd. Deel de link waar je wil.",
      SIGNUP_EMAIL_SENT: "Gelukt! Check je email om je account te activeren!",
      ACCOUNT_CREATED: "Gelukt! Je account is direct aangemaakt.",
      NO_PAGE_ACCES: "Oopsie, registreer of log in om deze content te bekijken",
      PASSWORD_RESET_SENT: "Wachtwoord reset mail verzonden. Check je email",
      DISCOVER: "ontdek je",
      GOOD_MORNING: "Goedemorgen",
      GOOD_AFTERNOON: "Goedemiddag",
      GOOD_EVENING: "Goedenavond",
      WHAT_ARE_YOU_GOING_FOR: "waar ga je voor",
      YOUR_INTENTION_TODAY: "wat is je intentie vandaag?",
      YOUR_INTENTION: "wat is je intentie?",
      YOUR_CHALLENGE: "wat is je uitdaging?",
      MESSAGE_RECEIVED: "Je hebt een berichtje ontvangen",
      MESSAGE_DEFORMED: "Het berichtje kon helaas niet worden gedecodeerd",
      SECRET_FOUND: "Je hebt een geheim gevonden!",
      SURVEYS_ACTIVATED: "Survey pagina geactveerd",
      VERIFICATION_MAIL_RESENT:
        "Verificatie email opnieuw verzonden. Kijk in je inbox",
      DONATE_COFFEE_MESSAGE:
        "Ik werk met ❤️ aan deze app en drink graag samen koffie met iemand. Steun mijn werk en bedank me met",
      HELP_GROW_THIS_APP: "Help deze app groeien",
      ORDER_BOOK:
        "Bestel een uniek Soul-Profiler boek en ontdek je purpose op aarde",
      SENDFOX_ERROR: "Aanmelden voor nieuwsbrief mislukt",
    },
    warnings: {
      nameDate: "Vul naam en datum in",
      valid_email: "Vul een geldig email adres in",
      user_already_registered: "Gebruiker is al geregistreerd",
      LOGIN_REQUIRED: "Login of registreer om deze content te bekijken",
      PLEASE_FILL_ALL_FIELDS: "Vul alle velden in",
    },
    winds: {
      heart: { text: "Hart", code: "H" },
      north: { text: "Noord", code: "N" },
      east: { text: "Oost", code: "E" },
      south: { text: "Zuid", code: "S" },
      west: { text: "West", code: "W" },
    },
  },
  monthNames: [
    "januari",
    "februari",
    "maart",
    "april",
    "mei",
    "juni",
    "juli",
    "augustus",
    "september",
    "oktober",
    "november",
    "december",
  ],
  dayNames: [
    "zondag",
    "maandag",
    "dinsdag",
    "woensdag",
    "donderdag",
    "vrijdag",
    "zaterdag",
  ],
  dialogHelp: {
    title: "Over de Soul-Profiler App",
    explanation: `De Soul-Profiler is gebaseerd op de medicijnwiel numerologie. Het medicijnwiel komt uit de Noord-Amerikaanse Indianencultuur en is
    gebaseerd op je <b>geboortedatum</b>.<br /><br />De uitgerekende
    getallen in het wiel gaan over <b>balans</b> tussen mannelijke en
    vrouwelijke energie ♂♀. Een spel tussen naar buitengaande beweging en
    naar binnenkerende beweging .<br /><br />Het medicijnwiel wordt gebruikt
     om <b>inzicht</b> te geven inzicht
    <b>bij uitdagingen</b> in het leven. Het omvat een blauwdruk van jouw
    unieke creatiekrachten en kwaliteiten.`,
    buttonText: "Lees meer",
  },
  welcome: "Hoi en welkom",
  numMeanings: [
    "hartsverlangen",
    "verbinding",
    "communicatie t.o.v. een groep",
    "creativiteit & balans",
    "bouwen & spelen",
    "helderheid & begrip",
    "levensenergie",
    "kloppend maken",
    "dienstbaarheid",
    "leiderschap",
    "meesterschap",
    "afronden",
  ],
  numMeanings1: [
    "Innerlijk verlangen",
    "Connectie & Relatie",
    "Interactie met een groep",
    "Creativiteit & Balans",
    "Realiseren & Recreëren",
    "Wijsheid & Intelligentie",
    "Levenskracht & Energie",
    "Helen & In balans brengen",
    "Toewijding",
    "Regie nemen",
    "Expertise & Vakmanschap",
    "Volbrengen & Concluderen",
  ],
  minireading: {
    air: [
      "spiegelende gedachten",
      "mag vertrouwen op ingevingen of ideeën met hartsverlangen",
      "wil graag tegengestelde gedachtes met elkaar verbinden",
      "deelt graag gedachten en ideeën die diep in je leven met een groep",
      "ontvangt creatieve ideeën vanuit chaos en structuur",
      "speelt met ingevingen en gedachten en is ondernemend van geest",
      "ontvangt veel informatie, heldere gedachten of ingevingen",
      "tovert magische ingevingen en gedachten te voorschijn",
      "is vaak bezig met bedenken of het klopt in het hoofd",
      "krijgt behulpzame ingevingen, check ook of ze dienstbaar zijn aan jezelf",
      "mag leiding nemen over de ingevingen & ideeën",
      "kan als geen ander ideeën finetunen en verbeteren",
      "zorgt voor afronding in het denken en bij ideeën, zodat de volgende stap kan worden gezet",
    ],
    fire: [
      "spiegelt de acties van anderen",
      "brengt eenheid om stappen te zetten in de creatie",
      "verbindt ogenschijnlijke tegenstellingen met elkaar om in actie te komen",
      "communiceert wat in zich leeft met de groep om stap te zetten ",
      "is de balansbrenger of structuurbrenger en doet graag iets creatiefs met de handen",
      "mag er op los bouwen en spelen en is een echte doener",
      "is de helderheidsbrenger in praktische situaties. Jij maakt creaties duidelijker",
      "brengt levensenergie. Er kan worden doorgewerkt aan de magie van creatie",
      "maakt het liefst alles kloppend door of te lijmen of te breken",
      "zorgt dat de creatie dienstbaar is aan zichzelf. Alleen dan ontstaat er een bezielde creatie",
      "mag leiding nemen over de acties in een creatieproces",
      "is meester in finetuning van de acties die gezet mogen worden",
      "brengt afronding van de acties. Hop, klaar en volgende stap!",
    ],
    water: [
      "spiegeltje, spiegeltje",
      "vraagt zich vaak af of er wel van jullie gehouden wordt",
      "Verbindt zich het liefst met de ander, maar vind dit tegelijkertijd het moeilijkst",
      "heeft knikkende knietjes om in een groep te delen wat er in jullie omgaat en dat is helemaal ok",
      "is een geboren artist of ordeschepper, maar voelt dat zelf niet zo.",
      "heeft moeite met ondernemen, maar is eigenlijk de beste ondernemer",
      "mag de twijfel omarmen over het niet weten of snappen. Je mag echt op je intuïtie en kennis gaan vertrouwen",
      "heeft moeite met levensenergie. Jij voelt de energie als geen ander",
      "mag het spannend blijven vinden om dingen te doorbreken of kloppend te maken",
      "is een geboren dienaar. Zorg dat je creaties ook echt dienstbaar zijn aan jezelf",
      "zal zich waarschijnlijk altijd en overal verantwoordelijk voor blijven voelen",
      "mag er op vertrouwen dat er genoeg kennis aanwezig is",
      "mag even de tijd nemen om een creatie af te ronden. Jij voelt de benodigde afrondende communicatie aan",
    ],
    earth: [
      "spiegelende realiteit",
      "vindt het fijn om gewoon te zijn met hartsverbinding",
      "wil zich graag verbinden met het aardse lichaam",
      "bevindt zich graag in een groep waar het veilig voelt",
      "heeft te maken met creativiteit en balans in de materie",
      "is graag in een ondernemende omgeving. Een 'speeltuin' kent geen geheimen voor jou",
      "vertoeft graag in een spirituele leer- en leefomgeving",
      "kan voor magie zorgen door gewoon aanwezig te zijn",
      "kan voor heling zorgen in de materie en lichaam",
      "mag dienstbaar en zorgzaam zijn voor zichzelf en anderen",
      "zorgt ervoor dat mensen graag bij je zijn met jouw leiderschap",
      "geniet volledig om aanwezig te zijn in een aardse leeromgeving",
      "is blij met afgerond projecten of processen. Zal graag het laatste woord hebben",
    ],
    heart: [
      "gaat open voor iemand die jou spiegelt",
      "is erg subtiel, is op zoek naar liefde en gaat open voor iemand met passie",
      "is erg subtiel, houdt van connectie en gaat open voor iemand die verbindt",
      "is erg subtiel, houdt van communiceren en gaat open voor iemand die deelt wat er in hem of haar leeft",
      "is heel subtiel, houdt van balans en gaat open voor iemand die creatief is of voor structuur zorgt",
      "is heel subtiel, houdt van spelen en gaat open voor iemand die speels en ondernemend is",
      "is erg subtiel, houdt van informatie en gaat open voor iemand die helderheid brengt",
      "is erg subtiel, houdt van magie en gaat open voor iemand met energie",
      "is erg subtiel, houdt ervan als dingen kloppen en gaat open voor iemand met helende of doorbrekende kwaliteiten",
      "is erg subtel, houdt van zorgzaaamheid en gaat open voor iemand die dienstbaar is",
      "is erg subtiel, houdt van regie en gaat open voor iemand die leiding neemt",
      "is erg subtiel, houdt van vakmanschap en gaat open voor iemand met kennis of kunde",
      "is erg subtiel, houdt van afronden en gaat open voor iemand die kan afronden",
    ],
  },
  creationNumbers1: {
    0: {
      title: "De ultieme spiegel",
      negative: "negatief spiegelen",
      positive: "positief spiegelen",
    },
    1: {
      title: "Hartsverlangen",
      negative: "zonder bezieling",
      positive: "opgaan in anderen",
    },
    2: {
      title: "Verbinding",
      negative: "uit contact",
      positive: "in verbinding",
    },
    3: {
      title: "Communicatie t.o.v. een groep",
      negative: "niet praten, wegkuipen",
      positive: "veel praten, geen inhoud",
    },
    4: {
      title: "Creativiteit & balans",
      negative: "structuur",
      positive: "chaos",
    },
    5: { title: "Bouwen & spelen", negative: "passief", positive: "actief" },
    6: {
      title: "Helderheid & begrip",
      negative: "medium",
      positive: "professor",
    },
    7: {
      title: "Levensenergie",
      negative: "depressie",
      positive: "magie",
    },
    8: { title: "Kloppend maken", negative: "lijmen", positive: "kapot maken" },
    9: { title: "Dienstbaarheid", negative: "pleaser", positive: "egoist" },
    10: {
      title: "Leiderschap",
      negative: "machteloos",
      positive: "bij machte",
    },
    11: {
      title: "Meesterschap",
      negative: "leerling, onwetend",
      positive: "leraar, belerend",
    },
    12: {
      title: "Afronding",
      negative: "niet aan beginnen",
      positive: "snel afraffelen",
    },
  },
  creationNumbers2: {
    0: {
      title: "De ultieme spiegel",
      negative: "negatief spiegelen, schaduwkant",
      positive: "positief spiegelen, lichtkant",
    },
    1: {
      title: "Hartsverbinding & Zielsverlangen",
      negative: "zonder bezieling",
      positive: "opgaan in eenheid",
    },
    2: {
      title: "Verbinding & Relatie",
      negative: "uit contact",
      positive: "in verbinding",
    },
    3: {
      title: "Interactie met een groep",
      negative: "niet praten, wegkuipen",
      positive: "veel praten, geen inhoud",
    },
    4: {
      title: "Creativiteit & Balans",
      negative: "rigide structuur",
      positive: "complete chaos",
    },
    5: {
      title: "Bouwen & Spelen",
      negative: "passief, niks doen",
      positive: "actief, zonder fundering",
    },
    6: {
      title: "Wijsheid & Intelligentie",
      negative: "zweef medium",
      positive: "koppige professor",
    },
    7: {
      title: "Levenskracht & Energie",
      negative: "depressie, ingehouden verdriet",
      positive: "magie, droomwereld",
    },
    8: {
      title: "Helen & Herstellen",
      negative: "lijmen, heel maken",
      positive: "kapot maken, breken",
    },
    9: {
      title: "Toewijding & Hulpvaardigheid",
      negative: "pleaser, slijmerd",
      positive: "egoist, narcistisch",
    },
    10: {
      title: "Leiding & Verantwoordelijk",
      negative: "machteloos, niet in staat",
      positive: "bij machte, autoritair leider",
    },
    11: {
      title: "Expertise & Vakmanschap",
      negative: "leerling, volgeling",
      positive: "leraar, instructeur",
    },
    12: {
      title: "Volbrengen & Concluderen",
      negative: "niet aan beginnen, vermijden",
      positive: "afraffelen, haastwerk",
    },
  },
  elements: {
    heart: {
      name: "Hart",
      element: "Hart",
      code: "H",
      icon: "favorite",
      direction: "Hart",
      wind: "Hart",
      wheel: "Zielstrilling",
      power: "Hartsverlangen",
      loveRelation: "Essentie van de relatie",
      energy: "Liefdes energie",
      color: "#a52422",
      backgroundcolor: "#fceeee",
    },
    air: {
      name: "denken",
      element: "Lucht",
      code: "N",
      icon: "air",
      direction: "Noord",
      wind: "Noorden",
      wheel: "Levensdoel",
      power: "Denkkracht",
      loveRelation: "Relatiedoel",
      energy: "Vluchtige energie",
      color: "#008f8f",
      backgroundcolor: "#ebffff",
    },
    fire: {
      name: "Doen",
      element: "Vuur",
      code: "E",
      icon: "whatshot",
      direction: "Oost",
      wind: "Oosten",
      wheel: "Talent",
      power: "Actiekracht",
      loveRelation: "Speelveld ",
      energy: "Actieve energie",
      color: "#ff7700",
      backgroundcolor: "#fff4eb",
    },
    water: {
      name: "Voelen",
      element: "Water",
      code: "S",
      icon: "water",
      direction: "zuid",
      wind: "Zuiden",
      wheel: "Karma",
      power: "Voelkracht",
      loveRelation: "Jullie moeilijkste thema",
      energy: "Stromende energie",
      color: "#3f88c5",
      backgroundcolor: "#eff5fa",
    },
    earth: {
      name: "zijn",
      element: "Aarde",
      code: "W",
      icon: "terrain",
      direction: "West",
      wind: "Westen",
      wheel: "Levenspad",
      power: "Zijnskracht",
      loveRelation: "Speelveld ",
      energy: "Langzame energie",
      color: "#3d2600",
      backgroundcolor: "#fff7eb",
    },
  },
  dayEnergyOptions: {
    0: [
      "Ik spiegel mensen",
      "Ik ben de ultieme spiegel",
      "Mijn leegheid is liefde",
      "Ik breng heling door te spiegelen",
    ],
    1: [
      "Ik laat mijn hartsverlangen groeien",
      "Vandaag geef ik mijn hartsverlangen wat meer aandacht",
      "Eenheid is vandaag voor mij het toverwoord",
      "Mijn hartsverbinding straalt de wereld in",
    ],
    2: [
      "Ik verbind mij met de andere kant",
      "Ik verbind tegengestelde gedachten met elkaar",
      "Het is vandaag tijd om tegenstellingen te verbinden",
      "Ik laat vandaag het mannelijke en het vrouwelijke samenwerken",
    ],
    3: [
      "Vandaag communiceer ik wat er ten diepste in mij leeft",
      "Ik toon mijn gevoel aan anderen",
      "Ik communiceer mijn hartsverlangen naar de buitenwereld",
      "Ik mag me vandaag even helemaal in mijn cocon terugtrekken",
    ],
    4: [
      "Ik belichaam creativiteit vandaag",
      "Vandaag ben ik de balansbrenger",
      "Ik toon mijn kunsten!",
      "Ik word blij van wat ik creëer",
    ],
    5: [
      "Bouw en speeltijd! Ik zorg wel voor een goede fundering",
      "Tijd om te ondernemen!",
      "Ik werk aan mijn belangrijkste creatie",
      "Ik zet vandaag de stappen die nodig zijn",
    ],
    6: [
      "Ik ontvang vandaag de helderheid die nodig is",
      "Ik vertrouw op mijn intuïtie vandaag",
      "Vandaag speel ik de professor",
      "Ik zorg voor een heldere mind",
    ],
    7: [
      "Ik laat mijn ingehouden verdriet los",
      "Stuiterbal dag!",
      "Ik zorg voor een vleugje magie vandaag",
      "Ik hebt echt genoeg energie vandaag",
    ],
    8: [
      "Vandaag is doorbreekdag",
      "Ik gebruik mijn helende kracht vandaag",
      "Ik ga vandaag iets lijmen of doorbreken?",
      "Het klopt of het klopt niet. Ik maak het gewoon kloppend",
    ],
    9: [
      "Ik ben vandaag dienstbaar zijn aan mezelf",
      "Ik zorg vandaag goed voor mezelf",
      "Door goed voor mezelf te zorgen, zorg ik voor anderen",
      "Ik speel vandaag met de egoïst en de pleaser in mij",
    ],
    10: [
      "Ik pak vandaag de verantwoordelijkheid over mezelf",
      "Vandaag neem ik de leiding",
      "Ik speel met mijn machtige energie",
      "Ik mag vandaag de onmacht toelaten",
    ],
    11: [
      "Vandaag ga ik een creatie finetunen",
      "Ik heb genoeg informatie verzameld voor vandaag",
      "Ik draag mijn meesterschap uit naar de buitenwereld",
      "Het hoeft niet altijd perfect te zijn",
    ],
    12: [
      "Ik rond vandaag een aantal zaken af",
      "Ik neem vandaag mijn tijd, zonder af te afraffelen",
      "Vandaag zet ik een stap om iets af te ronden",
      "Ik communiceer vandaag wat er nog gecommuniceerd  moet worden",
    ],
  },
  loveHeart: {
    0: ["Samen spiegelen jullie je omgeving"],
    1: [
      "Jullie houden van het liefdes gevoel",
      "Hartsverlangen is jullie zielstrlling als liefdeskoppel",
      "Samensmelten als één is jullie hartsverbinding",
      "Als jullie bij elkaar zijn stralen jullie liefde de wereld in",
    ],
    2: [
      "Jullie gezamelijk liefdeshart verbindt tegenstellingen",
      "Samen verbinden jullie het mannelijke en het vrouwelijke hart",
      "Ogenschijnlijke tegenstellingen komen samen in jullie hart",
    ],
    3: [
      "Vandaag communiceer ik wat er ten diepste in mij leeft",
      "Ik toon mijn gevoel aan anderen",
      "Ik communiceer mijn hartsverlangen naar de buitenwereld",
      "Ik mag me vandaag even helemaal in mijn cocon terugtrekken",
    ],
    4: [
      "Ik belichaam creativiteit vandaag",
      "Vandaag ben ik de balansbrenger",
      "Ik toon mijn kunsten!",
      "Ik word blij van wat ik creëer",
    ],
    5: [
      "Bouw en speeltijd! Ik zorg wel voor een goede fundering",
      "Tijd om te ondernemen!",
      "Ik werk aan mijn belangrijkste creatie",
      "Ik zet vandaag de stappen die nodig zijn",
    ],
    6: [
      "Ik ontvang vandaag de helderheid die nodig is",
      "Ik vertrouw op mijn intuïtie vandaag",
      "Vandaag speel ik de professor",
      "Ik zorg voor een heldere mind",
    ],
    7: [
      "Ik laat mijn ingehouden verdriet los",
      "Stuiterbal dag!",
      "Ik zorg voor een vleugje magie vandaag",
      "Ik hebt echt genoeg energie vandaag",
    ],
    8: [
      "Vandaag is doorbreekdag",
      "Ik gebruik mijn helende kracht vandaag",
      "Ik ga vandaag iets lijmen of doorbreken?",
      "Het klopt of het klopt niet. Ik maak het gewoon kloppend",
    ],
    9: [
      "Ik mag vandaag dienstbaar zijn aan mezelf",
      "Ik zorg vandaag goed voor mezelf",
      "Door goed voor mezelf te zorgen, zorg ik voor anderen",
      "Ik speel vandaag met de egoïst en de pleaser in mij",
    ],
    10: [
      "Ik pak vandaag de verantwoordelijkheid over mezelf",
      "Vandaag neem ik de leiding",
      "Ik speel met mijn machtige energie",
      "Ik mag vandaag de onmacht toelaten",
    ],
    11: [
      "Vandaag ga ik een creatie finetunen",
      "Ik heb genoeg informatie verzameld voor vandaag",
      "Ik draag mijn meesterschap uit naar de buitenwereld",
      "Het hoeft niet altijd perfect te zijn",
    ],
    12: [
      "Jullie houden van afronding",
      "Afrondende communicatie is jullie zielstrilling",
      "Jullie gezamelijke hartsverlangen is afronden",
    ],
  },
  textHeart: {
    0: ["Ultieme spiegel", "zuivere spiegel", "Leegheid", "Het alles"],
    1: ["hartsverlangen", "hartsverbinding", "eenheid", "liefde"],
    2: ["verbinding", "verbondenheid", "tegenstelling overbruggen"],
    3: ["communicatie vanuit je hart", "Praten ten opzichte van een groep"],
    4: ["creativiteit", "balans", "chaos", "structuur"],
    5: ["spelen", "bouwen", "ondernemen", "dichten", ""],
    6: [
      "helderheid",
      "een heldere lucht",
      "helderheid en begrip",
      "een heldere mind",
    ],
    7: ["magie", "verdriet", "levensenergie"],
    8: [
      "helende hartsenergie",
      "helende energie",
      "doorbrekend verlangen",
      "helend hartsverlangen",
    ],
    9: ["zorgen", "dienstbaar", "over"],
    10: ["verantwoordelijkheid", "leiderschap", "krachtig leiderschap"],
    11: ["Leraar", "leerling", "meester"],
    12: ["afronding", "afondende hartsenergie", "afrondende communicatie"],
  },
  textNorth: {
    0: [
      "de gedachten spiegel zijn",
      "ultieme spiegel zijn",
      "de leegte te omarmen ",
      "ideeen spiegelen",
    ],
    1: [
      "je hartsverlangen in je ideeen stoppen",
      "de ingevingen over je hratsverlangen volgen",
      "eenheid bevorderen",
    ],
    2: [
      "verbindingen leggen",
      "tegenstellingen verbinden",
      "mensen verbinden",
      "het mannelijke en het vrouwelijke verbinden",
      "het positieve met het negatieve verbinden",
    ],
    3: [
      "communiceren wat er ten diepste in je leeft",
      "praten over je zielsmissie",
      "groepen toespreken",
    ],
    4: ["creeeren", "balans brengen", "structuur brengen", "je kunsten tonen"],
    5: [
      "speelsheid brengen",
      "funderingen bouwen",
      "ondernemen vanuit je hart",
      "gewoon altijd bouwen & spelen",
    ],
    6: [
      "helderdere ideeen inzetten",
      "informatie verhelderen",
      "heldere ideologie brengen",
      "je ingevingen volgen",
    ],
    7: ["magische ideeen inzetten", "levensenergie brengen"],
    8: ["helen", "doorbreken", "lijmen"],
    9: ["dienstbaar zijn", "dienstbare ideeen inzetten", "dienstbaar zijn"],
    10: ["verantwoordelijkheid nemen", "leiderschap tonen", "leiding nemen"],
    11: ["meesterlijke ideeen", "meesterschap brengen"],
    12: ["afronden", "volmaken", "klaren"],
  },
  textEast: {
    0: [
      "en mensen spiegelen",
      "en mensen naar zichzelf brengen",
      "en de leegheid omarmen",
    ],
    1: [
      "en je hartsverlangen inzetten",
      "en hartsverbindingen herstellen",
      "en eenheid brengen",
    ],
    2: [
      "en verbindingen leggen",
      "en tegenstellingen blijven verbinden",
      "en mensen verbinden",
      "en mensen samenbrengen",
    ],
    3: [
      "en communiceren wat er ten diepste in je leeft",
      "en comuniceren over je zielsmissie",
      "en groepen toespreken met je hart",
    ],
    4: [
      "en gewoon blijven creeeren",
      "en balans brengen",
      "en structuur brengen",
      "en je kunsten tonen",
    ],
    5: [
      "en speelsheid brengen",
      "en een stevige fundering bouwen",
      "en ondernemende acties doen",
      "en gewoon blijven bouwen",
    ],
    6: [
      "en helderheid scheppen",
      "en informatie verhelderen ",
      "en duidelijkheid scheppen",
      "en helderheid brengen",
    ],
    7: [
      "en magie te voorschijn toveren",
      "en energie brengen",
      "en levensenergie opwekken",
    ],
    8: [
      "en helende acties doen",
      "en gewoonten doorbreken",
      "en binnen en buiten bij elkaar brengen",
      "en de bullshit verwijderen",
      "en heling brengen",
    ],
    9: [
      "en dienstbaarheid tonen",
      "en dienstbare actiestappen zetten",
      "en dienstbaarheid inzetten",
    ],
    10: [
      "en verantwoordelijkheid nemen",
      "en leiderschap tonen",
      "en leiding nemen",
    ],
    11: [
      "en je meesterschap inzetten",
      "en jouw kennis delen",
      "en de kennis finetunen",
    ],
    12: [
      "en afrondende energie brengen",
      "en afrondende acties maken",
      "en voor afronding zorgen",
    ],
  },
  textWest: {
    1: [
      "met jouw hartsverlangen in de wereld",
      "voor hartsverbinding met je lichaam",
      "voor eenheid",
    ],
    2: [
      "om verbindingen te leggen",
      "om tegenstellingen te verbinden",
      "om mensen te verbinden",
    ],
    3: [
      "en gewoon helemaal jezelf zijn in een groep",
      "met groepen mensen",
      "en daarmee groepen toespreken",
      "uitspreken wat er ten diepste in je leeft voor een groep",
    ],
    4: [
      "voor een creatieve omgeving",
      "om balans te brengen in de realiteit",
      "en de wereld om je heen te ordenen",
      "en je kunsten te tonen",
    ],
    5: [
      "om speelsheid te brengen",
      "om funderingen te bouwen",
      "om te ondernemen met materie",
      "om een nieuwe realiteit te bouwen",
    ],
    6: [
      "helderheid scheppen",
      "informatie verhelderen ",
      "duidelijkheid scheppen",
    ],
    7: [
      "voor een magische realiteit",
      "voor meer levensenergie in de materie",
      "voor een sprankelende werkelijkheid",
    ],
    8: [
      "voor een kloppende realiteit",
      "voor een realiteit zonder bullshit",
      "voor spirituele groei",
      "voor heling in de materie",
    ],
    9: [
      "zodat je dienstbaar kan zijn aan de nieuwe wereld",
      "om dienstbaar te zijn voor een nog mooiere realiteit",
      "door goed voor je lichaam te zorgen",
    ],
    10: [
      "verantwoordelijkheid in de materie",
      "leiderschap tonen door er te zijn",
      "verantwoordelijkheid nemen over je lichaam",
    ],
    11: [
      "voor kennis van de materie ",
      "voor kennis van een nieuwe realteit",
      "meester te zijn",
    ],
    12: [
      "voor afronding in de realiteit",
      "om zaken af te ronden",
      "voor afrondende communcatie",
    ],
  },
  textSouth: {
    1: ["hartsverlangen", "hartsverbinding", "eenheid"],
    2: ["verbinding", "relaties"],
    3: [
      "communiceren wat er ten diepste in je leeft",
      "communiceren tov groep",
      "groepen toespreken",
    ],
    4: ["creativiteit & balans"],
    5: ["spelen & bouwen", "ondernemen"],
    6: ["helderheid & begrip", "informatie"],
    7: ["levensenergie", "depressie & magie"],
    8: ["kloppend maken", "helen"],
    9: ["dienstbaarheid", "zorgen"],
    10: ["verantwoordelijkheid", "leiderschap"],
    11: ["Meesterschap", "Kennis"],
    12: ["afronden", "beeindigen", "voltooien", "afsluiten", "volbrengen"],
  },
};
